import React from 'react';
import { cn } from '@bem-react/classname';
import './OneCatalog.style.scss';

import { PdfViewer } from '@components/PdfViewer';
const CnOneCatalog = cn('one-catalog');

const OneCatalog = () => {
  return (
    <div className={CnOneCatalog()}>
      <PdfViewer file={'catalog.pdf'} />
    </div>
  );
};

export default OneCatalog;
